import OutdatedBrowser from "./outdated-browser";

export default OutdatedBrowser;
